import React from 'react';
import { _formatPrice } from '../../function/functions';

const MintingTableMobile = ({
	firstAmount,
	totalAmount,
	membershipLevel,
	textData,
	discountPercent,
}) => {
	return (
		<div className='minting_table_mobile'>
			<div className='price_bar'>
				<div className='price_header'>
					<div className='header_left'>
						<p id='price'>{textData.minting.price}</p>
					</div>
					<div className='header_right'>
						<p id='final_price'>{textData.minting.final_price}</p>
						<p id='dummy'></p>
					</div>
				</div>

				<div className='price_about'>
					<div className='price_data'>
						<div className='price_price'>
							<p className='price_name'>ETH</p>
							<span>{_formatPrice(firstAmount.eth)}</span>
							{/* 현재가 적용 데이터 */}
							<p>ETH</p>
						</div>
						<div className='price_right'>
							<div className='price_final_price'>
								<span>{_formatPrice(totalAmount.eth)}</span>
								{/* 할인가 적용 데이터 */}
								<p>ETH</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='member_discount'>
				<div className='price_last_data'>
					<p className='price_last_data_text'>Membership level</p>
					<p className='price_last_data_result'>
						{membershipLevel.toUpperCase()}
					</p>
					{/* 멤비쉽 레벨 데이터 */}
				</div>
				<div className='price_last_data'>
					<p className='price_last_data_text'>Discount rate</p>
					<p className='price_last_data_result'>
						{(discountPercent * 100).toFixed()}%
					</p>
					{/* 멤비쉽 레벨 데이터 */}
				</div>
			</div>
		</div>
	);
};

export default MintingTableMobile;
